import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <ContactSection />
        <UpdatesSection />
        <IndexSection />
        <AppSection />
        <CardsSection />
        <RankingSection />
        <MediaSection />
        <CommentsSection />
        <FaqSection />
        <AboutSection />
        <CarouselSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}